import { useEffect } from 'react'
import { ToastContainer } from 'react-toastify'
import styled from 'styled-components'
import { useMsal } from '@azure/msal-react'
import { initialize } from 'react-ga'

import 'react-toastify/dist/ReactToastify.css'

import { logger } from './utils/logger'
import environnement from './infrastructure/config/environnement'
import Router from './ui/components/router/router'
import { Navigation } from './ui/modules/navigation/navigation'
import { loginRequestExt, loginRequestInt } from './infrastructure/authbymsal'
import { useAuthenticationUseCase } from './application/useCases/useAuthentication'
import { useStore } from './application/store/store'
import { AUTH_TYPE } from './infrastructure/enums/authentication.enum'

const Content = styled.div`
  padding: 0;
  margin: 0;
  display: flex;
  overflow-y: auto;
  flex: 1;
`

const Container = styled.div`
  font-family: ${(props: { theme: { fonts: { primary: string } } }) => props.theme.fonts.primary};
  color: ${(props: { theme: { colors: { white: string } } }) => props.theme.colors.white};
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  position: fixed;
`

const App = (props: { selectedType: string }) => {
  const { selectedType } = props
  const { accounts, instance } = useMsal()
  const { setUserAuthentication, user } = useStore()
  const { getCurrentUser } = useAuthenticationUseCase()

  useEffect(() => {
    const isLoggingOut = localStorage.getItem('isLoggingOut')
    if (!isLoggingOut) {
      if (accounts.length === 0 && selectedType) {
        try {
          instance.loginRedirect(
            selectedType === AUTH_TYPE.EXTERNAL ? loginRequestExt : loginRequestInt
          )

          localStorage.setItem('selectedType', selectedType)
        } catch (error) {
          localStorage.setItem('selectedType', '')
          logger.error(`App ${error}`)
        }
      }
    } else {
      localStorage.removeItem('isLoggingOut')
    }
  }, [accounts, instance, selectedType])

  useEffect(() => {
    const getUser = async () => {
      const user = await getCurrentUser()
      if (user) {
        setUserAuthentication(user)
      }
    }
    if (accounts.length > 0) {
      getUser()
    }
  }, [accounts])

  initialize(environnement.GOOGLE_ANALYTICS, {
    gaOptions: {
      userId: user.email,
    },
  })

  return (
    <Container>
      {accounts.length ? (
        <>
          <ToastContainer />
          <Navigation />
          <Content>
            <Router />
          </Content>
        </>
      ) : null}
    </Container>
  )
}

export default App
